/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CurrentUserDetails } from "../models/currentUserDetails";

import type { GetApiUserContextAssumeParams } from "../models/getApiUserContextAssumeParams";

import type { GetApiUserContextParams } from "../models/getApiUserContextParams";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get User Context
 */
export const getApiUserContext = (
  params?: GetApiUserContextParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<CurrentUserDetails>(
    { url: `/api/user-context`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiUserContextQueryKey = (
  params?: GetApiUserContextParams,
) => {
  return [`/api/user-context`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUserContextQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUserContext>>
  > = ({ signal, meta }) =>
    getApiUserContext(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserContext>>
>;
export type GetApiUserContextQueryError = ErrorType<unknown>;

export function useGetApiUserContext<
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetApiUserContextParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserContext>>,
          TError,
          Awaited<ReturnType<typeof getApiUserContext>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUserContext<
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserContext>>,
          TError,
          Awaited<ReturnType<typeof getApiUserContext>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUserContext<
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Context
 */

export function useGetApiUserContext<
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiUserContextQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get User Context
 */
export const prefetchGetApiUserContext = async <
  TData = Awaited<ReturnType<typeof getApiUserContext>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetApiUserContextParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetApiUserContextQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Assume Context
 */
export const getApiUserContextAssume = (
  params?: GetApiUserContextAssumeParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    { url: `/api/user-context/assume`, method: "GET", params, signal },
    options,
  );
};

export const getGetApiUserContextAssumeQueryKey = (
  params?: GetApiUserContextAssumeParams,
) => {
  return [`/api/user-context/assume`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserContextAssumeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextAssumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUserContextAssumeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUserContextAssume>>
  > = ({ signal, meta }) =>
    getApiUserContextAssume(params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserContextAssume>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserContextAssumeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserContextAssume>>
>;
export type GetApiUserContextAssumeQueryError = ErrorType<unknown>;

export function useGetApiUserContextAssume<
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetApiUserContextAssumeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserContextAssume>>,
          TError,
          Awaited<ReturnType<typeof getApiUserContextAssume>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUserContextAssume<
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextAssumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserContextAssume>>,
          TError,
          Awaited<ReturnType<typeof getApiUserContextAssume>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUserContextAssume<
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextAssumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Assume Context
 */

export function useGetApiUserContextAssume<
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  params?: GetApiUserContextAssumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiUserContextAssumeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assume Context
 */
export const prefetchGetApiUserContextAssume = async <
  TData = Awaited<ReturnType<typeof getApiUserContextAssume>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: GetApiUserContextAssumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUserContextAssume>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetApiUserContextAssumeQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
